/* eslint-disable jsx-a11y/alt-text */
import styles from "./Skills.module.css";
import javascript from "../../images/skills/javascript.svg";
import html from "../../images/skills/html.svg";
import css from "../../images/skills/css.svg";
import react from "../../images/skills/react.svg";
import typescript from "../../images/skills/typescript.svg";
import nodejs from "../../images/skills/nodejs.svg";
import mongodb from "../../images/skills/mongodb.svg";
import postgresql from "../../images/skills/postgresql.svg";
const Skills = () => {
  return (
    <div className={styles.skills} id="skills">
      <h1> Habilidades </h1>
      <p>Conheça um pouco das minhas principais habilidades e conhecimentos.</p>

      <div>
        <img src={javascript} />
        <img src={html} />
        <img src={css} />
        <img src={react} />
        <img src={typescript} />
        <img src={nodejs} />
        <img src={mongodb} />
        <img src={postgresql} />
      </div>
    </div>
  );
};

export default Skills;
